const MINUTE_IN_MS = 60 * 1000;
const HOUR_IN_MS = 60 * MINUTE_IN_MS;
const DAY_IN_MS = 24 * HOUR_IN_MS;
const WEEK_IN_MS = 7 * DAY_IN_MS;

const pluralize = (value: number, unit: string): string => {
  return `${value} ${unit}${value === 1 ? '' : 's'} ago`;
};

export const formatActivityFeedTime = (value?: string | null): string => {
  if (!value) return '—';

  const timestamp = new Date(value).getTime();
  if (Number.isNaN(timestamp)) return '—';

  const diff = Math.max(Date.now() - timestamp, 0);

  if (diff < MINUTE_IN_MS) return 'Just now';
  if (diff < HOUR_IN_MS) return pluralize(Math.floor(diff / MINUTE_IN_MS), 'min');
  if (diff < DAY_IN_MS) return pluralize(Math.floor(diff / HOUR_IN_MS), 'hour');
  if (diff < WEEK_IN_MS) return pluralize(Math.floor(diff / DAY_IN_MS), 'day');

  return pluralize(Math.floor(diff / WEEK_IN_MS), 'week');
};

export const formatActivityFeedQueryDate = (
  value: Date | null | undefined,
  boundary: 'start' | 'end',
): string | undefined => {
  if (!value) return undefined;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return undefined;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const time = boundary === 'start' ? '00:00:00' : '23:59:59';

  return `${year}-${month}-${day} ${time}`;
};
